// RenderStaticData.js
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import "./RenderStaticData.css";
import TextWrapperPrice from "Components/TextWrapperPrice/TextWrapperPrice";
import {
  dropShadowLowStyle,
  spacingFluidMedium,
  spacingFluidSmall,
  spacingFluidXLarge,
  spacingFluidXSmall,
} from "@porsche-design-system/components-js/styles";
import TextWrapperGeneral from "Components/TextWrapperGeneral/TextWrapperGeneral";
import { useGetTileBaseStyleDrop } from "MainApp/assets/visual/styles/globalStyles/globalJsxStyles";
import CButton from "Components/CComponents/CButton/CButton";
import CText from "Components/CComponents/CText/CText";
import { AuthContext } from "MainApp/assets/utils/context/AuthContext";
import { getIntlLocale } from "MainApp/assets/utils/js/localeUtils";

const RenderStaticData = ({
  time,
  date,
  totalPrice,
  formData,
  isFormIncompleteProp,
  handleConfirmAndSetAppointment,
  texts,
  currency,
  isPhone,
  pickupConfig,
}) => {
  // const currency = "€";

  const { isTuk } = useContext(AuthContext);
  const { i18n } = useTranslation();

  return (
    // <div className='bg-rose-500 h-full'>
    <div
      className="testCol"
      style={{
        gap: spacingFluidXLarge,
        padding: spacingFluidMedium,
        justifyContent: isPhone ? "space-between" : "",
        ...useGetTileBaseStyleDrop(),
        ...dropShadowLowStyle,
      }}
    >
      <div
        className="flex flex-col"
        style={{ gap: isPhone ? spacingFluidXLarge : spacingFluidMedium }}
      >
        <CText weight="bold" size="x-large">
          {texts("resume.head")}
        </CText>

        <CText weight="bold" size="large">
          {formData.tour}
        </CText>
        {/* <h1 className="confirmationTitle" style={titleStyle}>
                {texts("resume.head}
            </h1> */}
        <div className="flex flex-col" style={{ gap: spacingFluidSmall }}>
          <div
            className="flex flex-col"
            style={{
              gap: spacingFluidXSmall,
              ...(isTuk ? {color: "#333" } : { color: "white" }), // Si isTuk es falso, aplica color blanco
            }} // style={{ gap: spacingFluidSmall }}
          >
          </div>

            <TextWrapperGeneral
              // pcolor={isTukColor}
              className="confirmationDetail"
              text={`${texts("resume.startHour")}: `}
              value={time}
            />
            <TextWrapperGeneral
              // pcolor={isTukColor}
              className="confirmationDetail"
              text={`${texts("resume.date")}: `}
              value={new Date(date).toLocaleDateString(
                getIntlLocale(i18n.language)
              )}
            />

          {pickupConfig?.requested && (
            <TextWrapperGeneral
              className="confirmationDetail"
              text={`${texts("resume.customPickup", "Recogida personalizada")}: `}
              value={
                pickupConfig.chargeAmount > 0
                  ? pickupConfig.chargeAmount
                  : texts("resume.included", "Incluida")
              }
              currency={pickupConfig.chargeAmount > 0 ? currency : ""}
              size="medium"
            />
          )}

          <TextWrapperGeneral
            text={`${texts("resume.vehicle")} x${formData.totalUnits}:`}
            value={totalPrice}
            currency={currency}
            size="medium"
          />
        </div>
      </div>
      <div
        className="flex flex-col"
        style={{ gap: isPhone ? spacingFluidMedium : spacingFluidSmall }}
      >
        <TextWrapperPrice
          text={`${texts("resume.totalPrice")}:`}
          price={totalPrice}
          currency={currency}
          isTotal={true}
          weight="bold"
        />
        <CButton
          className="confirmButton"
          onClick={handleConfirmAndSetAppointment}
          disabled={isFormIncompleteProp}
          style={{ marginTop: spacingFluidMedium }}
        >
          {texts("resume.confirmButton")}
        </CButton>
      </div>
    </div>
    // </div>
  );
};

export default RenderStaticData;
